<template>
  <page
    layout="double"
    inverted
    class="rentalPage"
  >
    <template v-slot:left>
      <page>
        <div class="firstLine">
          <h4>{{ $t('rentals.rentalNb') }}{{ 'AR0123456789' }}</h4>
          <p>
            {{ $t('rentals.balance') }}&nbsp;0,00€&nbsp;
            <md-icon name="sentiment_satisfied_alt" />
          </p>
        </div>
        <p>{{ $t('rentals.yours') }} <el-link>{{ $t('rentals.record') }}</el-link> {{ $t('rentals.identifiedBy') }} <span>{{ 123456789 }}</span>.</p>
        <p>{{ $t('rentals.contractOk') }} <span>{{ '01/09/2019' }} {{ $t('rentals.to') }} {{ '30/06/2019' }}</span>.</p>
        <rental-payouts />
        <rental-files />
      </page>
    </template>
    <template v-slot:right>
      <rental-balance />
      <rental-messages />
      <rental-residence />
    </template>
  </page>
</template>

<script>
import RentalBalance from '@/components/rentals/RentalBalance'
import RentalFiles from '@/components/rentals/RentalFiles'
import RentalMessages from '@/components/rentals/RentalMessages'
import RentalPayouts from '@/components/rentals/RentalPayouts'
import RentalResidence from '@/components/rentals/RentalResidence'

export default {
  name: 'Rental',
  components: {
    RentalBalance,
    RentalFiles,
    RentalMessages,
    RentalPayouts,
    RentalResidence
  }
}
</script>

<style lang="scss" scoped>
$c: '.rentalPage';

#{$c} {
  .firstLine {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;

    p {
      color: $--color-success;
      font-size: 18px;

      display: flex;
      align-items: center;
    }
  }

  p {
    span {
      color: $--color-primary;
    }
  }

  .pageComponent__right {
    & > div:not(:first-child) {
      margin-top: 1rem;
    }
  }
}
</style>